import React, { useRef, useEffect } from "react";
import "./Resume.css";
import { EDUCATION, WORK } from "../../Utils/data";
import ResumeCard from "./ResumeCard/ResumeCard";
import Slider from "react-slick";
import EducationCard from "./EducationCard/EducationCard";
import AOS from "aos";
import "aos/dist/aos.css";

const Resume = () => {
  const workSliderRef = useRef();
  const educationSliderRef = useRef();

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slideWorkRight = () => {
    workSliderRef.current.slickNext();
  };

  const slideWorkLeft = () => {
    workSliderRef.current.slickPrev();
  };

  const slideEducationRight = () => {
    educationSliderRef.current.slickNext();
  };

  const slideEducationLeft = () => {
    educationSliderRef.current.slickPrev();
  };

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-sine",
      delay: 50,
    });
  }, []);

  return (
    <section className="resume">
      <div className="resume-container">
      <h2 className="resume-title">Resume</h2>
        <div className="resume-content">
          <h3>Work Experience</h3>
          <div className="arrow-right" onClick={slideWorkRight} data-aos="fade-left">
            <span className="material-symbols-outlined">&#9658;</span>
          </div>
          <div className="arrow-left" onClick={slideWorkLeft} data-aos="fade-left">
            <span className="material-symbols-outlined">&#9668;</span>
          </div>
          <Slider ref={workSliderRef} {...settings}>
            {WORK.map((item) => (
              <ResumeCard key={item.title} details={item} />
            ))}
          </Slider>
          <h3>Education</h3>
          <div className="right" onClick={slideEducationRight} data-aos="fade-right">
            <span className="material-symbols-outlined">&#9658;</span>
          </div>
          <div className="left" onClick={slideEducationLeft} data-aos="fade-right">
            <span className="material-symbols-outlined">&#9668;</span>
          </div>
          <Slider ref={educationSliderRef} {...settings}>
            {EDUCATION.map((item) => (
              <EducationCard key={item.school} info={item} />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Resume;
